import messages from './tag-messages.js';
export default [
    {tag: 'Characters', intlLabel: messages.characters},
    {tag: 'Doodads', intlLabel: messages.doodads}
];
